import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetCars'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetCarsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetCarsStore",
			variables: false,
		})
	}
}

export async function load_GetCars(params) {
  await initClient()

	const store = new GetCarsStore()

	await store.fetch(params)

	return {
		GetCars: store,
	}
}
